document.addEventListener("DOMContentLoaded", function () {
  // const menuItems = document.querySelectorAll(".mgmenu_item");
  // const activeMegaMenu = document.querySelector(
  //   ".maga_menu--inner-wrapper.mashine-menu"
  // );

  // menuItems.forEach((menuItem) => {
  //   menuItem.addEventListener("mouseenter", function () {
  //     const parentSelector = menuItem.dataset.child;
  //     const matchingChildren = document.querySelectorAll(
  //       `[data-parent="${parentSelector}"]`
  //     );
  //     menuItem.classList.add("active");
  //     matchingChildren.forEach((child) => {
  //       child.classList.add("active");
  //     });
  //   });
  // });

  // // Add event listener to the menu area for mouseleave event if activeMegaMenu exists
  // if (activeMegaMenu) {
  //   activeMegaMenu.addEventListener("mouseleave", function (event) {
  //     // Remove 'active' class from menu items and their children
  //     activeMegaMenu.classList.remove("active");
  //   });
  // }

  const headings = document.querySelectorAll(".tab-heading");
  const contents = document.querySelectorAll(".tab-contant");

  headings.forEach(function (heading, index) {
    heading.addEventListener("click", function () {
      headings.forEach(function (h) {
        h.classList.remove("active");
      });
      contents.forEach(function (content) {
        content.classList.remove("active");
      });

      heading.classList.add("active");
      contents[index].classList.add("active");
    });
  });

  // Initialize the first tab as active
  if (headings.length > 0) {
    headings[0].classList.add("active");
    contents[0].classList.add("active");
  }
});
